export function resolveNetworkPanelSsoUrl(content) {
  if (!content) {
    return null;
  }
  if (typeof content === 'string') {
    return content;
  }
  if (typeof content === 'object') {
    if (typeof content.url === 'string') {
      return content.url;
    }
    if (typeof content.content === 'string') {
      return content.content;
    }
    if (content.content && typeof content.content.url === 'string') {
      return content.content.url;
    }
  }
  return null;
}
